const ZT_LIVE_DATA_SERVICES = ['ZapierFormatterDevAPI', 'CodeAPI', 'FilterAPI'];

export default function isLiveDataRequired(serviceKey: string) {
  // For now, we use app source in ZT only for Formatter and Code
  return ZT_LIVE_DATA_SERVICES.includes(serviceKey);
}
